module.exports = __webpack_public_path__ + "img/1002.344661d5.svg";